/*

[
 {
    description: 'Enable creation of a new tenant instead of selecting one you are invited to',
    key: 'PRODUCT_HUB_UI/TOGGLES/ENABLE_CREATE_TENANT',
    exampleValue: true,
    defaultValue: false,
    schema: { type: 'boolean' }
  }
]



*/

export enum ProductHubToggles {
	ENABLE_CREATE_TENANT = 'ENABLE_CREATE_TENANT',
	ENABLE_RELEASE_NOTES_PAGE = 'ENABLE_RELEASE_NOTES_PAGE'
}

export const TOGGLES_DETAILS = [
	{
		name: ProductHubToggles.ENABLE_CREATE_TENANT,
		label: 'Enable creation of a new tenant instead of selecting one you are invited to'
	},
	{
		name: ProductHubToggles.ENABLE_RELEASE_NOTES_PAGE,
		label: 'Enable Release Notes page'
	}
];

export const getToggleFromLocalStorage = (toggle: ProductHubToggles): boolean => {
	const value = localStorage.getItem(toggle);
	// cast the string value to it's boolean equivalent
	return value === 'true';
};

export const setToggle = (toggle: ProductHubToggles, value: string): void => {
	localStorage.setItem(toggle, value);
};

export const removeToggle = (toggle: ProductHubToggles): void => {
	localStorage.removeItem(toggle);
};
